import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2>Ops Sorry!</h2>
            <h4>404s</h4>
        </div>
    );
};

export default NotFound;